import Link from 'next/link';
import AdSlotWrapper from '@/components/AdSlotWrapper';
import TechnologyNewsletterForm from './TechnologyNewsletterForm';
import ArticleAuthorLinks from '@/components/ArticleAuthorLinks';
import { magazineReadingTime } from '@/theme-library/magazine/1.0.0/data';

const SLOT_IDS = {
  homepage: ['homepage_sidebar_1', 'homepage_sidebar_2', 'homepage_sidebar_3'],
  category: ['homepage_sidebar_1', 'homepage_sidebar_2', 'homepage_sidebar_3'],
  article: ['article_sidebar_1', 'homepage_sidebar_2', 'homepage_sidebar_3'],
};

export default function TechnologySidebar({ articles = [], settings = {}, context = 'homepage' }) {
  const slots = SLOT_IDS[context] || SLOT_IDS.homepage;
  const mostRead = [...articles]
    .sort((left, right) => (Number(right.views) || 0) - (Number(left.views) || 0) || new Date(right.publishedAt || right.date || 0) - new Date(left.publishedAt || left.date || 0))
    .slice(0, 4);

  return (
    <aside className="flex w-full flex-col gap-9">
      <AdSlotWrapper id={slots[0]} settings={settings} className="flex w-full items-center justify-center border border-[#d1d1d1] bg-white" style={{ minHeight: '420px' }} />
      {mostRead.length > 0 && (
        <section data-technology-most-read>
          <h3 className="mb-5 border-t-2 border-black pt-3 text-xl font-black tracking-tight text-black">Most Read</h3>
          <div className="flex flex-col gap-6">
            {mostRead.map(article => (
              <article key={article.id} className="group block">
                <Link href={article.url || `/${article.slug}`}>
                <div className="aspect-[4/3] overflow-hidden bg-[#f5f5f5]">
                  <img src={article.image || '/placeholder.jpg'} alt={article.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                </div>
                <h4 className="mt-2 text-sm font-bold leading-snug text-black transition-colors group-hover:text-[#929191]">{article.title}</h4>
                </Link>
                <p className="mt-2 text-xs leading-relaxed text-[#666666]"><ArticleAuthorLinks article={article} />
                  {magazineReadingTime(article.content) !== null && <span> · {magazineReadingTime(article.content)} min read</span>}
                </p>
              </article>
            ))}
          </div>
        </section>
      )}
      <AdSlotWrapper id={slots[1]} settings={settings} className="flex w-full items-center justify-center border border-[#d1d1d1] bg-white" style={{ minHeight: '250px' }} />
      <TechnologyNewsletterForm />
      <AdSlotWrapper id={slots[2]} settings={settings} className="flex w-full items-center justify-center border border-[#d1d1d1] bg-white" style={{ minHeight: '250px' }} />
    </aside>
  );
}
